export { default as WizardStore } from './WizardStore';



// WEBPACK FOOTER //
// ./src/modules/product/wizard/stores/index.js